import styled from '@emotion/styled';
import { Button } from '@lbcamden/lib-react';
import { Link } from 'react-router';

const ButtonLinkBase = Button.withComponent(Link);

export const ButtonLink = styled(ButtonLinkBase)`
  &:hover {
    color: ${({ theme }) => theme.colors.textNegative};
  }
`;
